import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { tap } from 'rxjs';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { PeriodicalValue } from 'src/app/shared/model/PeriodicalValue';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { PeriodicalValueService } from 'src/app/shared/services/periodical-value.service';
import { EditPeriodicalValueComponent } from '../../custom/edit-periodical-value/edit-periodical-value.component';

@Component({
  selector: 'app-periodical-value-input-ctrl',
  templateUrl: './periodical-value-input.component.html',
  styleUrls: ['./periodical-value-input.component.scss']
})
export class PeriodicalValueInputComponent implements OnInit {

  constructor(
    private periodicalValueService: PeriodicalValueService,
    private customDialogService: CustomDialogService
  ) { }

  @Input() identifier:string;
  @Input() referenceDate = new Date();
  @Input() caption:string;

  currentPeriodicalValue : PeriodicalValue = null;
  isLoading = false;

  @ViewChild("editPeriodicalDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  ngOnInit(): void {
    
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.periodicalValueService.getPeriodicalValueForDate(this.identifier, null).pipe(
      tap(() => this.isLoading = false)
    )
      .subscribe(
        (r) => this.currentPeriodicalValue = r
      );
  }

  edit(){
    const dialogSettings: CustomDialogSettings = {
      content: EditPeriodicalValueComponent,
      minHeight: '20vh',
      minWidth: '20vw',
      maxHeight: '95vh',
      maxWidth: '95vw',
      appendTo: this.containerRef,
      dialogInputs: {
        identifier: this.identifier
      },
      resultCallback: (r: DialogResult) => {
        if(r['text'] == 'OK') {
          this.loadData();
         }
      }
    };
    this.customDialogService.showDialog(dialogSettings);
  }

}
